export default "__VITE_ASSET__C0nfZwU3__"